import { render, staticRenderFns } from "./SuggestedLink.vue?vue&type=template&id=c98ad85a&scoped=true"
import script from "./SuggestedLink.vue?vue&type=script&lang=js"
export * from "./SuggestedLink.vue?vue&type=script&lang=js"
import style0 from "./SuggestedLink.vue?vue&type=style&index=0&id=c98ad85a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98ad85a",
  null
  
)

export default component.exports